<template>
  <img :src="thumbImage" class="thumb-image" alt="thumb" />
</template>

<script>
import { DEFAULT_IMG } from '@/constants/constant';
import { getImageUrl } from '@/utils/utils';

export default {
  name: 'ThumbImage',

  props: {
    src: {
      type: String,
      default: DEFAULT_IMG
    },
    width: {
      type: [String, Number],
      default: 0
    },
    height: {
      type: [String, Number],
      default: 0
    }
  },

  computed: {
    thumbImage() {
      const width = parseInt(this.width, 10);
      const height = parseInt(this.height, 10);

      return getImageUrl(`${width}x${height}`, this.src);
    }
  }
};
</script>

<style lang="less">
.thumb-image {
  width: 100%;
  height: 100%;
}
</style>
